import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type TUserState = {
  user: { sid: string; url: string } | null;
  rnsSetSuccess: boolean;
  rnsUsername: string;
};

// states
const initialState: TUserState = {
  user: null,
  rnsSetSuccess: false,
  rnsUsername: "",
};

// slice
const userSlice = createSlice({
  name: "USER",
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<{ sid: string; url: string }>) {
      state.user = action.payload;
    },
    setRnsSetSuccess(state, action: PayloadAction<boolean>) {
      state.rnsSetSuccess = action.payload;
    },
    setRnsUsername(state, action: PayloadAction<string>) {
      state.rnsUsername = action.payload;
    },
  },
});

export default userSlice.reducer;
export const userActions = userSlice.actions;
